import React, { useContext } from "react";
import { InformationListContext } from "../../../provider/InformationListProvider";
import { Paginate } from "../../common/button/paginate/Paginate";

export const InformationListPager = React.memo(function InformationListPager() {
    const {
        pageCount,
        currentPage,
        handleInformationPager
    } = useContext(InformationListContext);

    return (
        <div className={"page_button_area"}>
            <Paginate pageCount={pageCount} onPageChange={handleInformationPager} currentPage={currentPage} />
        </div>
    );
});
